import { render, staticRenderFns } from "./FormulaIeb.vue?vue&type=template&id=1ede0d62&"
import script from "./FormulaIeb.vue?vue&type=script&lang=js&"
export * from "./FormulaIeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VChip,VContainer})
